import React, { useState, useEffect } from 'react';
import * as XLSX from 'xlsx';
import {
  Box,
  Container,
  Typography,
  Button,
  FormControl,
  IconButton
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import Selector from '../../../../components/Selector';
import { fetchCategorias, fetchAlmacenes } from '../../../../utils/generalsFetch';
import { capitalizeFirstLetter } from '../../../../utils/generalFunctions';
import { RemoveCircleOutline } from '@mui/icons-material';
import { catInventarioCamposObligatorios,catInventarioGenericoCamposObligatorios } from '../../../../utils/staticvariables';

const ImportProducts = ({ onClose }) => {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [categories, setCategories] = useState([]);
  const [campos, setCampos] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedAlmacen, setSelectedAlmacen] = useState('');
  const [type, setType] = useState('');
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [almacenes, setAlmacenes] = useState([]);
  useEffect(() => {
    fetchCategorias({
      idcompany: localStorage.getItem('idcompany'),
      usuarioId: localStorage.getItem('id')
    }).then((data) => {
      setCategories(data);
    });
    fetchAlmacenes({
      idcompany: localStorage.getItem('idcompany'),
      usuarioId: localStorage.getItem('id')
    }).then((data) => {
      setAlmacenes(data);
    });
  }, []);

  const handleCategoryChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedCategory(selectedValue);
    setType(categories.find(cat => cat.value == selectedValue).tipo)
    const found = categories.find((cat) => cat.value === selectedValue);
    if (found && found.fields) {
      setCampos(JSON.parse(found.fields));
    } else {
      setCampos([]);
    }
  };

  const handleAlmacenChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedAlmacen(selectedValue);
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file || !selectedCategory || campos.length === 0) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: 'array' });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      if (jsonData.length > 0) {
        const dataRows = jsonData;

        const dynamicColumns = campos.map((campo) => ({
          field: campo.id,
          headerName: capitalizeFirstLetter(campo.alias!='' ? campo.alias : campo.name),
          flex: 1,
          editable: campo.id !== 'id' // id is not editable
        }));

        dynamicColumns.push({
          field: 'category',
          headerName: 'Categoría',
          flex: 1,
          editable: false,
          valueGetter: () =>
            selectedCategory
              ? categories.find((c) => c.value === selectedCategory)?.label || selectedCategory
              : '',
          editable: false
        });

        dynamicColumns.push({
          field: 'valid',
          headerName: 'Estado',
          flex: 1,
          renderCell: (params) => (
            <Button
              variant="outlined"
              size="small"
              sx={{ borderRadius: 5 }}
              color={params.value ? 'success' : 'error'}
            >
              {params.value ? 'Válido' : 'Inválido'}
            </Button>
          )
        });

        dynamicColumns.push({
          field: 'actions',
          headerName: '',
          flex: 0.5,
          sortable: false,
          renderCell: (params) => (
            <IconButton onClick={() => handleDeleteRow(params.id)} color="error">
              <RemoveCircleOutline />
            </IconButton>
          )
        });

        const processedRows = dataRows
          .slice(1)
          .map((row, index) => {
            const rowData = { id: index };

            campos.forEach((campo, colIdx) => {
              const key = campo.id;
              rowData[key] = row[colIdx] ?? '';
            });

            rowData.category = selectedCategory;
            rowData.valid = campos.every((campo) => {
              const key = campo.id;
              console.log(key,rowData[key]);
              return rowData[key]?.toString().trim() !== '';
            });

            // Always return a row object; skip completely empty lines later
            return rowData;
          })
          .filter((row) =>
            campos.some((campo) => (row[campo.id] ?? '').toString().trim() !== '')
          );


        setColumns(dynamicColumns);
        setRows(processedRows);
      }
    };

    reader.readAsArrayBuffer(file);
  };

  const processRowUpdate = (newRow, oldRow) => {
    // Validate the row
    const isValid = campos.every((campo) => {
      const key = campo.id;
      return newRow[key]?.toString().trim() !== '';
    });
    return { ...newRow, valid: isValid };
  };

  const handleRowsChange = (updatedRows) => {
    setRows(updatedRows);
  };

  const handleDeleteRow = (id) => {
    setRows((prev) => prev.filter((row) => row.id !== id));
  };

  const validCount = rows.filter((r) => r.valid).length;
  const invalidCount = rows.length - validCount;

  const importProducts = async () => {
  
    var objects = rows.map(row => {
      var object = {}
      campos.forEach(campo => {
        // Verificar si el campo es obligatorio según catInventarioCamposObligatorios
        // catInventarioCamposObligatorios es un array de objetos con propiedad 'id'
        const isObligatorio = catInventarioCamposObligatorios.some(ob => ob.id === campo.id);
        if(isObligatorio){
          object[campo.id] = row[campo.id]
          object["campos"] = {
            ...object["campos"],
            [campo.id]: row[campo.id]
          }
        }
        else{
          object["campos"] = {
            ...object["campos"],
            [campo.id]: row[campo.id]
          }
        }

      })
      return object
    })


    try {
      const response = await fetch(process.env.REACT_APP_SERVER_URL + '/api/productos/importar', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany')
        },
        body: JSON.stringify({
          productos: objects,
          idcategoria: selectedCategory,
          idcompany: localStorage.getItem('idcompany'),
          idalmacen: selectedAlmacen,
          created_by: localStorage.getItem('id')
        })
      });

      if (!response.ok) {
        throw new Error('Error al importar los productos');
      }

      const result = await response.json();
      // Puedes mostrar un mensaje de éxito o cerrar el modal
      if (onClose) onClose();
    } catch (error) {
      alert(error.message || 'Ocurrió un error al importar los productos');
    }



    
  }

  return (
    <Box>
      <Box sx={{width: "70%",justifyContent: "center",alignItems: "center",margin: "0 auto" }}>
        <Typography variant="h4" fontWeight={700}>
          Importar productos desde Excel
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={1} mb={4}>
          Carga tus productos desde un archivo Excel. Puedes editar directamente antes de confirmar la importación.
        </Typography>

        <FormControl fullWidth sx={{ mb: 3 }}>
          <Selector
            value={selectedCategory}
            onChange={handleCategoryChange}
            options={categories}
            placeholder="Categoría"
          />
        </FormControl>
        <FormControl fullWidth sx={{ mb: 3 }}>
          <Selector
            value={selectedAlmacen}
            onChange={handleAlmacenChange}
            options={almacenes}
            placeholder="Almacén"
          />
        </FormControl>

        <Box
          border="2px dashed #dde1e3"
          borderRadius={2}
          p={6}
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
        >
          <Typography fontWeight={700}>Arrastra y suelta tu archivo aquí</Typography>
          <Typography variant="body2">O</Typography>
          <Button variant="outlined" component="label" sx={{ borderRadius: 5 }} disabled={!selectedCategory || !selectedAlmacen}>
            Seleccionar archivo
            <input type="file" hidden accept=".xlsx,.xls" onChange={handleFileUpload} />
          </Button>
        </Box>

        <Typography variant="body2" mt={2} mb={4}>
          Formatos permitidos: .xlsx y .csv
        </Typography>
      </Box>
        {rows.length > 0 && (
          <>
            <Typography variant="h6" fontWeight={700} mb={2}>
              Vista previa editable
            </Typography>
            <Box sx={{ width: '100%'}}>
              <Box sx={{ minWidth: 1200 }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 25]}
                  disableSelectionOnClick
                  processRowUpdate={processRowUpdate}
                  experimentalFeatures={{ newEditingApi: true }}
                  sx={{
                    '& .MuiDataGrid-columnHeaders': {
                      backgroundColor: 'primary.main',
                    },
                    '& .MuiDataGrid-columnHeadersInner': {
                      backgroundColor: 'primary.main',
                    },
                    '& .MuiDataGrid-columnHeader': {
                      backgroundColor: 'primary.main',
                      color: '#fff',
                    },
                    '& .MuiDataGrid-columnHeaderTitle': {
                      fontWeight: 'bold',
                      textAlign: 'center',
                      width: '100%',
                      display: 'block',
                    },
                    '& .MuiDataGrid-columnSeparator': {
                      display: 'none',
                    },
                    '& .MuiDataGrid-cell': {
                      textAlign: 'center',
                      justifyContent: 'left',
                      alignItems: 'left',
                      display: 'flex',
                    },
                  }}
                />
              </Box>
            </Box>

            <Typography variant="h6" fontWeight={700} mt={4}>
              Confirmación
            </Typography>
            <Typography variant="body1" mb={2}>
              {validCount} productos válidos, {invalidCount} con errores.
            </Typography>

            <Box sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', bgcolor: 'white', p: 2, borderTop: '1px solid #eee', textAlign: 'right', }}>
              <Button variant="outlined" sx={{width:200,fontWeight:"bold", marginRight:5}} onClick={onClose}>
                  Cancelar
              </Button>

              <Button
                variant="contained"
                color="primarybutton"
                disabled={validCount === 0 || selectedAlmacen == '' || selectedCategory == ''}
                sx={{ fontWeight: 'bold' }}
                onClick={importProducts}
              >
                Importar productos válidos
              </Button>

          </Box>


            
          </>
        )}
    </Box>
  );
};

export default ImportProducts;
